import { useLang } from "@/lib/i18n";
import { hoursLine } from "@/lib/hours";

/**
 * The opening hours as one quiet pill — the single shape every surface reads,
 * from the editors' live preview to the business detail card. A short line
 * reads as a pill; a place whose hours are written out at length keeps the
 * same quiet surface but opens into a block so every day stays legible.
 */
export default function HoursPill({ week, line = "", className = "" }) {
  const { lang, t } = useLang();
  const text = hoursLine(week, line, lang, t("hours.daily"));
  if (!text) return null;

  const pill = text.length <= 30;
  return (
    <div
      className={[
        "rounded-[10px] border border-[#deded9] bg-white text-[#3f3f3c] leading-[1.5]",
        pill ? "inline-flex px-3 py-2 text-[12px] font-semibold" : "block px-3 py-2.5 text-[12px] whitespace-normal break-words",
        className,
      ].filter(Boolean).join(" ")}
      aria-label={lang === "es" ? "Horario de apertura" : "Opening hours"}
    >
      {text}
    </div>
  );
}